import { get, post } from './axios.js'

/**
 * 이벤트 상세조회 - /event/eventSelect
 * @param {object} params
 * @property {string} params.ev_seq
 * @returns
 */
export async function eventSelect(params = {}) {
  try {
    const result = await post('/event/eventSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 이벤트 등록/수정 - /event/eventEdit
 * @param {object} params
 * @property {string} params.ev_seq
 * @property {string} params.event_nm
 * @property {string} params.event_dt
 * @property {string} params.event_place
 * @property {string} params.sponsor
 * @property {string} params.prpss
 * @property {string} params.prsnt
 * @property {string} params.event_dtls
 * @property {string} params.event_scale
 * @property {string} params.gift
 * @property {string} params.mk_fund
 * @property {string} params.claim_cost
 * @property {string} params.claim_mthd
 * @property {string} params.tmp_yn
 * @property {string} params.del_yn
 * @property {object} params.attachFileVO
 * @property {string} params.attachFileVO.file_div_id
 * @property {string} params.attachFileVO.file_seq
 * @property {string} params.attachFileVO.del_file_seq

 * @returns
 */
export async function eventEdit(params = {}) {
  try {
    const result = await post('/event/eventEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 이벤트 조회 - /event/eventList
 * @param {object} params
 * @property {string} params.ev_seq
 * @property {string} params.fs_year - 회계년도   
 * @property {string} params.event_nm -이벤트명
 * @property {string} params.prpss - 목적
 * @property {string} params.start_dt
 * @property {string} params.end_dt
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function eventList(params = {}) {
  try {
    const result = await post('/event/eventList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}